import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/sharp-solid-svg-icons';
import React, { useState } from 'react';

import FormController from '@/components/form/formController';
import { IFormFieldProps } from '@/models/form/form';

import TextInput from '../textInput';

const PasswordInput: React.FC<IFormFieldProps> = (props: IFormFieldProps) => {
  const { control } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [focused, setFocused] = useState<boolean>(false);

  const additionalProps = {
    endAdornment: focused // If focused is false, use normal adornment, otherwise, use this one
      ? () => {
          return (
            <button
              data-testid="clear-button"
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              <FontAwesomeIcon
                className="text-gray-70 hover:text-gray-100"
                icon={showPassword ? faEye : faEyeSlash}
                size="sm"
              />
            </button>
          );
        }
      : undefined,
    type: showPassword ? 'text' : 'password',
  };
  return (
    <div
      onBlur={(event) => {
        // Only set focused to false if the blurred click event is not a child element
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setFocused(false);
        }
      }}
      onFocus={() => setFocused(true)}
    >
      {control ? (
        <FormController {...props} FormField={TextInput} {...additionalProps} />
      ) : (
        <TextInput {...props} {...additionalProps} />
      )}
    </div>
  );
};

export default PasswordInput;
